<script>
// import { services } from '@src/utils/common-services'

export default {
  props: {
    menu: {
      type: Array,
      required: true,
    },
    menubar: {
      type: Boolean,
      default() {
        return true
      },
    },
  },
  data() {
    return {
      persistentNavRoutes: null,
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Login',
        },
      ],
    }
  },
  watch: {
    menu(newVal, oldVal) {
      if (newVal !== oldVal) this.persistentNavRoutes = this.menu
    },
  },
  mounted() {
    this.persistentNavRoutes = this.menu // services.getMainMenuList(this.currentUser)
  },
  beforeMount() {},
}
</script>
<template>
  <div v-if="persistentNavRoutes !== null" class="pb50-sm">
    <ul>
      <CommonBaseNavBarRoutes :routes="persistentNavRoutes" />
    </ul>
  </div>
</template>
